import BuildingModel from "./Component/BuildingModel";

function App() {

  return (
    <div className="App">
      <BuildingModel />
    </div>
  );
}

export default App;
